/**
 * Karbon360° v2 — CBAM entitlement gate.
 *
 * Every /cbam screen renders inside this. Three states, in order:
 *   1. Session still resolving  → Skeleton rows in a Card. billing_plan arrives
 *      async from /api/auth/me, so showing the upsell (or the screen) before it
 *      lands would flash the wrong surface at an entitled account.
 *   2. Plan does not qualify    → the upsell: what the module does and where to
 *      upgrade. The routes stay registered for everyone — visibility is
 *      convenience, the API is the boundary (requireCompliance on /api/cbam/*).
 *   3. Entitled                 → the screen itself.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from '../../components/v2/Icons';
import { Card, Button, Callout, Empty, Skeleton } from '../../components/v2/ui';
import { useSession } from '../../components/v2/session';
import { useT } from '../../i18n';

export default function CbamGate({ children }) {
  const { hasCbam, resolved } = useSession();
  const { t } = useT();
  const navigate = useNavigate();

  if (!resolved) {
    return (
      <Card>
        <Skeleton w="40%" style={{ marginBottom: 12 }} />
        <Skeleton style={{ marginBottom: 8 }} />
        <Skeleton style={{ marginBottom: 8 }} />
        <Skeleton w="65%" />
      </Card>
    );
  }

  if (!hasCbam) {
    return (
      <Card>
        <Empty
          icon={X.Globe}
          title={t('cbam.gate.title')}
          body={t('cbam.gate.body')}
          action={
            <Button variant="pri" onClick={() => navigate('/account')}>
              {t('cbam.gate.cta')}
            </Button>
          }
        />
        <Callout tone="info">{t('cbam.gate.info')}</Callout>
      </Card>
    );
  }

  return children;
}
